var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7874 35.8391H61.6663C62.9159 35.8391 63.9383 34.8168 63.9383 33.5672V14.2541C63.9383 13.0045 62.9159 11.9821 61.6663 11.9821H55.8236V32.972C55.8236 34.0587 55.434 35.0586 54.7874 35.8393V35.8391ZM1.36938 64.2678H12.2309C13.5186 64.2678 14.5723 63.2142 14.5723 61.9265V41.0889H1.36938V64.2679V64.2678ZM16.2113 62.0336H39.8352C43.63 62.378 59.6471 55.0032 67.5326 51.1063C69.4425 50.1625 68.6949 47.2639 66.5671 47.3615C63.2734 47.513 53.8429 49.7106 47.0354 51.1969C46.2049 52.0895 45.0241 52.6586 43.7862 52.4793L38.5301 51.7181L38.5287 51.7123L32.7629 50.88C32.0726 50.7813 31.4512 50.742 30.7457 51.0043C30.2337 51.1946 29.7439 51.5413 29.3326 52.1114C29.2053 52.2856 29.0143 52.4024 28.8012 52.4363C28.5882 52.4702 28.3704 52.4185 28.1953 52.2924C28.0202 52.1664 27.902 51.9762 27.8666 51.7634C27.8311 51.5506 27.8813 51.3324 28.006 51.1564C29.2426 49.4402 31.1281 48.9279 33.0192 49.2618V49.2623L44.0214 50.8557C45.9292 51.1318 48.0605 47.6635 45.192 46.4842L30.0973 40.2788C28.4236 39.5908 26.5419 39.6021 24.8303 40.2788L16.2128 43.6863V61.9266C16.2128 61.9624 16.2123 61.9982 16.2113 62.0338V62.0336ZM42.9752 5.73218H35.2834V19.3942L39.1293 17.1739L42.9751 19.3942V5.73218H42.9752ZM26.943 35.8393C25.366 35.8393 24.0758 34.5491 24.0758 32.9722V8.59931C24.0758 7.02239 25.366 5.73218 26.943 5.73218H33.6428V22.2358L39.1293 19.0683L44.6157 22.2358V5.73218H51.3156C52.8925 5.73218 54.1827 7.02239 54.1827 8.59931V32.9722C54.1827 34.5491 52.8925 35.8393 51.3156 35.8393H26.9429H26.943ZM23.4715 35.8393H16.8421C15.5925 35.8393 14.5701 34.8169 14.5701 33.5673V14.2541C14.5701 13.0045 15.5924 11.9821 16.8421 11.9821H22.4354V32.972C22.4354 34.0587 22.8249 35.0586 23.4715 35.8393Z",
    fill: "url(#paint0_linear_4_2166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2166",
    x1: 11.0733,
    y1: 12.3468,
    x2: 61.8933,
    y2: 68.9216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.fcaf70b9cef4c0a22719680efcebd60d.svg";
export { ForwardRef as ReactComponent };